import Trailer from '@/types/Trailer';
import FbaApiError from '@/types/FbaApiError';
import globalConstants from '@/shared/globalConstants';
import { isNullOrUndefined } from '@/shared/helpers';
import queries from '@/queries';

export const asTrailerOrNull = (value: unknown): Trailer | null => {
    if (!isNullOrUndefined(value) && value instanceof Trailer) {
        return value;
    }

    return null;
};

export interface TrailerLookupResult {
    trailer: Trailer | null;
    // True only when the trailer exists but its type isn't supported by the caller
    // (backend reasonCode InvalidTrailerType), as opposed to genuinely not found or a
    // failed request.
    isUnsupportedType: boolean;
}

export const lookupTrailerById = async (
    trailerNumber: string,
    company: string,
    allowRefrigerated = false
): Promise<TrailerLookupResult> => {
    const result = await queries.getTrailerById(
        trailerNumber,
        company,
        allowRefrigerated
    );

    const trailer = asTrailerOrNull(result);

    return {
        trailer,
        isUnsupportedType:
            trailer === null &&
            (result as FbaApiError | null | undefined)?.reasonCode ===
                globalConstants.reasonCodes.invalidTrailerType,
    };
};

export const findTrailerById = async (
    trailerNumber: string,
    company: string,
    allowRefrigerated = false
): Promise<Trailer | null> => {
    const { trailer } = await lookupTrailerById(
        trailerNumber,
        company,
        allowRefrigerated
    );

    return trailer;
};
